import { Blanket, BlanketImage, BlanketInfo } from "@/components/core/blanket";
import { ScrollArea } from "@/components/core/scroller";
import { Searchbar } from "@/components/core/searchbar";
import Tooltip from "@/components/core/tooltip";
import { Content } from "@/components/layouts/content";
import { Header } from "@/components/layouts/header";
import { IconDownload, IconFolderExclamation, IconPrinter } from "@tabler/icons-react";
import { createFileRoute } from "@tanstack/react-router";
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";

export const Route = createFileRoute("/_dashboard/serving_/$servingId")({
	component: RouteComponent,
});

function RouteComponent() {
	const documents = Array.from({ length: 30 }, (_, index) => ({
		id: index,
		title: `Document Title ${index + 1}`,
		description: `Some Description ${index + 1}`,
	}));

	return (
		<Content pageName="Document Service">
			{/*<Header title="Document Service" />*/}
			<PanelGroup className="flex flex-row grow w-full h-full" direction="horizontal">
				<Panel defaultSize={30} minSize={20} className="flex flex-col shrink-0 grow h-full max-w-[420px]">
					<div className="flex flex-col w-full gap-2 py-4 px-6 border-b border-border/50">
						<div className="inline-flex flex-col w-full">
							<span className="text-xl text-foreground-dark font-semibold">Documents</span>
							<span className="text-base text-foreground/70">Brief description for help here</span>
						</div>
						<Searchbar className="mb-1" />
					</div>
					<div className="flex flex-col w-full h-[calc(100svh-216px)] py-2">
						<ScrollArea>
							{documents.map((document) => (
								<button key={document.id} type="button" className="flex flex-col w-full px-6 py-2 rounded-md bg-background hover:bg-slate-50">
									<span className="text-base font-semibold text-foreground-dark">{document.title}</span>
									<span className="text-base text-foreground/70">{document.description}</span>
								</button>
							))}
						</ScrollArea>
					</div>
				</Panel>

				<PanelResizeHandle className="group flex justify-center items-center h-full w-[12px] border-r border-l border-border/50 bg-white">
					<div className="inline-flex w-[4px] h-[40px] rounded-sm bg-foreground/50 group-hover:bg-foreground/90" />
				</PanelResizeHandle>

				<Panel defaultSize={70} minSize={10} className="flex flex-col shrink grow w-full h-full">
					<div className="flex flex-col w-full h-[calc(100svh-90px)] bg-slate-100">
						<div className="sticky top-0 flex flex-row justify-between items-center w-full px-6 py-3 bg-background border-b border-border/50">
							<span className="font-semibold text-foreground-dark text-base">Document 1</span>
							<div className="inline-flex flex-row items-center w-auto gap-2">
								<Tooltip content="Print" side="top">
									<button className="text-foreground/50 hover:text-foreground" type="button">
										<IconPrinter size={18} stroke={2} />
									</button>
								</Tooltip>
								<Tooltip content="Download" side="top">
									<button className="text-foreground/50 hover:text-foreground" type="button">
										<IconDownload size={18} stroke={2} />
									</button>
								</Tooltip>
							</div>
						</div>
						<ScrollArea>
							<div className="flex flex-col justify-center items-center w-full">
								<Blanket width="sm">
									<BlanketImage icon={<IconFolderExclamation size={30} stroke={1.5} />} />
									<BlanketInfo title="No data found" message="Looks like you are looking for something non-existent. Be the first to add data for this page." />
								</Blanket>
							</div>
						</ScrollArea>
					</div>
				</Panel>
			</PanelGroup>
		</Content>
	);
}
